import React from "react";
import { Route, Switch, BrowserRouter as Router } from "react-router-dom";
import Home from "./mainbtn";
import QRread from "./qr/qrread";
import QRcreate from "./qr/qrcreate";
import Result from "./qr/qrresult/qrresult";
import Measurement from "./measurement/measurement";
import Manager from "./manager/manager_main";
import Header from "./header/header";
import End from "./qr/qrresult/end";
// import Manager_Login from "./manager/manager_login";
import Login from "./login";
import PhoneRead from "./qr/phoneread";
import DtRead from "./qr/dtread";
import Setting from "./setting";
import UserTrain from "./train";
import TrainBtn from "./trainBtn";

class Main extends React.Component {
  componentDidMount() {
    document.title = process.env.REACT_APP_SITE_TITLE || "국방지능형훈련관리플랫폼";
  }

  render() {
    return (
      <div className="background">
        <Router>
          <Header></Header>
          <div className="main">
            <Switch>
              <Route exact path="/" component={Login} />
              <Route path="/Main" component={Home} />
              <Route path="/MainTrain" component={TrainBtn} />
              <Route path="/QRread" component={QRread} />
              <Route path="/Phoneread" component={PhoneRead} />
              <Route path="/Dtread" component={DtRead} />
              <Route path="/QRcreate" component={QRcreate} />
              <Route path="/QRresult" component={Result} />
              <Route path="/measurement" component={Measurement} />
              {/* <Route path="/Login" component={Manager_Login} /> */}
              <Route path="/Manager" component={Manager} />
              <Route path="/End" component={End} />
              <Route path="/UserTrain" component={UserTrain} />
              <Route path="/Setting" component={Setting} />
            </Switch>
          </div>
        </Router>
      </div>
    );
  }
}

export default Main;
